<template>
  <div>

    <div class="title-section">
      <div class="display-1 font-weight-bold">{{meta.title}}</div>
      <div class="subheading">{{meta.subtitle}}</div>
    </div>


    <v-divider class="spacer"/><div class="headline font-weight-bold">Overview</div><v-divider class="div-after"/>
    <div class="body-1">
      For this checkpoint, I ended up writing some simple shaders using OSL and rendering them with Blender. The
      first shader relies on unsigned perlin noise that varies over time, and ultimately has an interesting
      internal pattern. The second shader built on top the first shader by adding in a displacement component,
      as well as an additional simplex noise component that varied some of the colors of the volume. The 
      results of each shader can be seen below. 
    </div>
    <v-img class="u-image" :src="require(`../assets/updates/12/purple.png`)"/>
      <div class="font-weight-medium">First Shader</div>
    <v-img class="u-image" :src="require(`../assets/updates/12/dis1.png`)"/>
      <div class="font-weight-medium">Second Shader With Displacement</div>
    <v-img class="u-image" :src="require(`../assets/updates/12/dis2.png`)"/>
      <div class="font-weight-medium">Second Shader With Displacement</div>
    <v-img class="u-image" :src="require(`../assets/updates/12/dis3.png`)"/>
      <div class="font-weight-medium">Second Shader With Displacement</div>
      


  </div>
</template>

<script>
import CardList from '../components/CardList';

export default {
  name: 'U_12',
  components: { CardList, },
  data() {
    return {
    };
  },
  computed: {
    meta() {
      return this.$store.state.updates[12];
    },
  },
}
</script>

<style>

</style>
